module.exports = __webpack_public_path__ + "static/img/introduce_5.3e1aee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce_5.png
// module id = j8Yw
// module chunks = 1